<div class="drug-precursor-container" [formGroup]="currentForm">
  <div id="drug-precursor-text" class="drug-precursor-text" [ngClass]="{ 'drug-precursor-text__full' : !isMobileDeviceSize }">
    Are any of the substances you are proposing to name a pro-drug?
  </div>
  <div class="radio-input-row">
    <input type="radio" aria-label="Yes" [id]="'proDrug'" [value]="'Yes'" name="drugPrecursorSelected" formControlName="isProDrug" (change)="updateValue('Yes')" [checked]="compareFn('Yes')">
    <label [for]="'proDrug'">Yes</label>
    <input type="radio" aria-label="No" [id]="'notProDrug'" [value]="'No'" name="drugPrecursorSelected" formControlName="isProDrug" (change)="updateValue('No')" [checked]="compareFn('No')">
    <label [for]="'notProDrug'">No</label>
  </div>
  <div class="drug-precursor-subtext">
    A compound that, on administration, must undergo chemical conversion by metabolic processes before becoming an
    active pharmacological agent; a precursor of a drug
  </div>
</div>